import { createButton } from '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export class StrikethroughPlugin {
    constructor() {
        this.name = 'strikethrough';
        this.spec = {
            type: 'mark',
            matchSelector: 's,strike',
            matchStyle: {
                'text-decoration': (deco) => /\bline-through\b/.test(deco) && {},
            },
            toDOM: 's',
        };
        this.toggle = () => this.editor.selection().toggleMark(this);
        this.isActive = () => this.editor.isActive(this);
        this.canApply = () => this.editor.selection().canToggleMark(this);
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                toggle: this.toggle,
                isActive: this.isActive,
            },
            shortcuts: {
                'Mod-d': this.toggle,
                'Mod-Shift-x': this.toggle,
            },
        };
    }
    renderToolbarItem() {
        const btn = createButton({
            label: this.editor.t('删除线'),
            shortcut: 'Mod-d',
            onclick: () => {
                this.editor.focus();
                this.toggle();
            },
        }, createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.strikethroughIcon),
        }));
        const setBtnProps = () => {
            btn.active = this.isActive();
            btn.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return btn;
    }
}
//# sourceMappingURL=index.js.map